'use client';

/**
 * Native overflow scrolling is used app-wide (hidden scrollbars via CSS).
 * Do not attach capture-phase wheel handlers — they replace smooth trackpad
 * scrolling with manual scrollTop updates and feel frozen/janky.
 *
 * Mounting this component is optional and currently a no-op kept for API stability.
 */
export function GlobalScrollWheel(_props?: { enabled?: boolean }) {
  return null;
}
